/* eslint-disable no-unused-vars*/
import React from 'react';
import { HasAccess } from '@permify/react-role';
import { Space, Table, Tag, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { deleteCategory } from 'api/category';
import { ButtonPrimary } from 'common/Button/Button.styles';
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { getCookie } from 'helper/cookie';
import Color from 'constants/color';
import { dataColor } from 'constants/tagColor';

const TableCategoryTutorial = (props: any) => {
  const { isLoading, data, renderData, pagination, onChangePage, navigate, token } = props;

  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const widthMobile = getCookie('widthMobile');

  const deleteData = async (id: any) => {
    Swal.fire({
      title: 'คุณแน่ใจว่าจะลบข้อมูลนี้',
      text: 'หากคุณลบแล้วจะไม่แสดงข้อมูลนี้',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: Color.primaryClick,
      // cancelButtonColor: '#d33',
      cancelButtonText: 'ยกเลิก',
      confirmButtonText: 'ต้องการลบข้อมูล',
      reverseButtons: true,
    }).then(async result => {
      if (result.isConfirmed) {
        const deleteData = await deleteCategory({ token: token, id });
        const { status, error, message } = deleteData;
        if (status === 200) {
          Swal.fire({
            title: 'Successful',
            text: 'Delete Success',
            icon: 'success',
            confirmButtonText: 'Close',
            showConfirmButton: false,
          });
          renderData(pagination);
        } else {
          Swal.fire({
            title: message,
            text: 'ไม่สามารถลบข้อมูลนี้ได้',
            icon: 'error',
            showConfirmButton: false,
            confirmButtonText: 'Close',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          });
        }
      }
    });
  };

  const columns: any = [
    {
      title: 'รหัส',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 70,
    },
    {
      title: 'รหัสหมวดหมู่วีดีโอ',
      dataIndex: 'category_tutorial_slug',
      key: 'category_tutorial_slug',
      align: 'center',
      width: 150,
      // responsive: ['sm'],
    },
    {
      title: 'ชื่อหมวดหมู่วีดีโอ',
      dataIndex: 'category_tutorial_name',
      key: 'category_tutorial_name',
      align: 'center',
      width: 150,
      // responsive: ['sm'],
    },
    {
      title: 'ระดับการมองเห็น',
      dataIndex: 'category_tutorial_view_type',
      key: 'category_tutorial_view_type',
      align: 'center',
      width: 200,
      render: (viewType: string) => {
        if (!viewType) return null; // Handle empty viewType

        // Split the view type string into an array and render it as a list of tags
        const viewTypesArray = viewType.split(',').filter(Boolean); // Filter out any empty strings

        // Get the color based on the view type index or match with text value
        const getTagColor = (type: string) => {
          const foundColor = dataColor.find(item => item.text === parseInt(type.trim()));
          return foundColor ? foundColor.color : 'default';
        };

        return (
          <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
            {viewTypesArray.map((type: string) => (
              <Tag color={getTagColor(type)} key={type} style={{ marginBottom: '4px' }}>
                {type.trim()}
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: 'สถานะ',
      dataIndex: 'category_tutorial_status',
      key: 'category_tutorial_status',
      align: 'center',
      width: 100,
      render: (data: any) => {
        return (
          <Tag
            color={data === 'Y' ? 'green' : 'red'}
            style={{
              width: '100%',
              textTransform: 'capitalize',
              textAlign: 'center',
            }}
          >
            {data === 'Y' ? 'active' : 'Inactive'}
          </Tag>
        );
      },
      // responsive: ['sm'],
    },
    {
      title: 'Action',
      align: 'center',
      width: 120,
      render: (data: any) => {
        return (
          <Space size={8}>
            <HasAccess
              // roles={'Masteradmin'}
              permissions={['category-edit']}
            >
              <Tooltip title="แก้ไขข้อมูล">
                <ButtonPrimary
                  onClick={() => navigate(`/backoffice/category_tutorial/edit/${data.id}`, { replace: true })}
                  style={{ width: '38px', height: '38px', padding: 0 }}
                >
                  <EditOutlined />
                </ButtonPrimary>
              </Tooltip>
            </HasAccess>
            {/* <div style={{ marginTop: '10px' }} />
                  <HasAccess
                     permissions={['category-delete']}
                  >
                     <Tooltip title="ลบข้อมูล">
                        <ButtonDelete
                           onClick={() => deleteData(data.id)}
                           style={{ width: '38px', height: '38px', padding: 0 }}
                        >
                           <DeleteOutlined />
                        </ButtonDelete>
                     </Tooltip>
                  </HasAccess> */}
          </Space>
        );
      },
      // responsive: ['sm'],
    },
  ];

  return (
    <>
      {isMobileView ? (
        <Table
          dataSource={data}
          columns={columns}
          bordered
          loading={isLoading}
          pagination={pagination}
          onChange={onChangePage}
          rowKey="id"
          // size="large"
          // scroll={}
          scroll={{ x: `${widthMobile}`, y: 600 }}
        />
      ) : (
        <Table dataSource={data} columns={columns} bordered loading={isLoading} pagination={pagination} onChange={onChangePage} rowKey="id" />
      )}
    </>
  );
};

export default TableCategoryTutorial;
